<template>
  <div
    class="modal fade"
    id="list-modal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="list-modalLabel"
    aria-hidden="true"
  >
    <div 
      class="modal-dialog modal-dialog-centered"
      :style="isWidthGreaterThan1000 ? 'max-width: 960px;' : ''"
      :class="isWidthGreaterThan1000 ? 'max-width-960' : ''"
    >
      <div class="modal-content">
        <div class="modal-body inner-container padding-0" style="padding-left: 0 !important;">
          <div class="customer-info-container" ref="customerInfoContainer">
            <div class="d-flex w-100 nft-list-modal-title">
              <h4>환자 정보 상세 보기</h4>
              <button
                v-if="!isWidthGreaterThan1000"
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                @click="scrollToTop"
              >
              <i class="fa-regular fa-x"/>
              </button>
            </div>
            <div class="customer-info">
              <div class="customer-info-row">
                <div class="customer-info-key">
                  <i class="fa-regular fa-user"/>
                  이름
                </div>
                <div class="customer-info-value">
                  {{ customerInfo?.name }}
                </div>
              </div>
              <div class="customer-info-row">
                <div class="customer-info-key">
                  <i class="fa-regular fa-phone"/>
                  연락처
                </div>
                <div class="customer-info-value">
                  {{ phoneNumberFormatter(customerInfo?.mobile) }}
                </div>
              </div>
              <div class="customer-info-row">
                <div class="customer-info-key">
                  <i class="fa-regular fa-calendar"/>
                  생년월일
                </div>
                <div class="customer-info-value">
                  {{ convertDate(customerInfo?.birth) }}
                </div>
              </div>
            </div>
            <div class="teeth-box-wrap" v-if="medicalDept?.length > 0 && medicalDept?.includes(MedicalDept.DENT)">
              <div class="teeth-area">
                <div class="teeth-container">
                  <div class="teeth-inner-container">
                    <div class="teeth-objects">
                      <div class="first-row">
                        <div v-for="(tooth, index) in firstRowTeethArray" class="teeth-and-margin">
                          <div 
                            :class="
                            index === 0 || tooth === 21
                            ? 'margin-8px' : 'margin-6px'
                            "
                          />
                          <div 
                            v-if="tooth === 21"
                            class="margin-8px"
                          />
                          <div class="teeth-object">
                            <img
                              @click="selectTooth(tooth)"
                              :src="getToothImageSrc(tooth)"
                            />
                          </div>
                          <div 
                            v-if="index === firstRowTeethArray?.length -  1"
                            class="margin-8px"
                          />
                        </div>
                      </div>
                      <div class="second-row" style="margin-right: 13px;">
                        <div v-for="(tooth, index) in secondRowTeethArray" class="teeth-and-margin">
                          <div 
                            :class="
                            index === 0
                            ? 'margin-16px' : 'margin-6px'
                            "
                          />
                          <div 
                            v-if="tooth === 31"
                            class="margin-10px"
                          />
                          <div class="teeth-object">
                            <img
                              @click="selectTooth(tooth)"
                              :src="getToothImageSrc(tooth)"
                            />
                          </div>
                          <div 
                            v-if="index === secondRowTeethArray?.length -  1"
                            class="margin-22px"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="teeth-frame">
                      <img class="teeth-frame-img" src="@/assets/img/tooth_images/teeth_frame.svg" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="division-bar"/>
            <div class="nft-list-container">
              <div class="d-flex justify-content-start w-100 nft-list-modal-title">
                <h4>발급 받은 인증서</h4>
              </div>
              <div class="nft-list">
                <div 
                  :id="'issueList' + i"
                  :ref="`issueList${i}`"
                  :tabindex="i"
                  @click="innerWidth > 1200 ? showMobile(i) : ''"
                  class="nft-item-wrap"
                  :class="showMobileViewIndex == i && innerWidth > 1000
                    ? 'selected' : ''"
                  v-for="(item, i) in nftList"
                  :key="i"  
                >
                  <div class="nft-image">
                    <img 
                    :src="getImageUrl(item)"
                    alt=""
                    />
                  </div>
                  <div class="nft-info">
                    <div class="nft-info-title" v-if="validateIsAvailable(item?.issueStatus)">{{ item?.products?.name }}</div>
                    <div class="nft-info-title" v-else>{{ generateTitleText(item?.issueStatus) }}</div>
                    <div v-if="validateIsAvailable(item.issueStatus)" class="nft-info-detail">{{ item?.descText }}</div>
                  </div>
                  <div class="right-area">
                    <div class="btn-container" v-if="validateIsAvailable(item?.issueStatus)">
                      <button @click="recallNft(item?._id, i)">회수</button>
                      <button @click="disposeNft(item?._id, i)">삭제</button>
                    </div>
                    <div 
                      class="nft-arrow"
                      :class="showMobileViewIndex === i && innerWidth > 1000
                      ? 'selected' : ''"
                    >
                      <i class="fa-regular fa-chevron-right"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="preview-container" v-if="isWidthGreaterThan1000">
            <div class="d-flex title-container w-100">
              <h4>인증서 상세보기</h4>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                @click="scrollToTop"
              >
              <i class="fa-regular fa-x"/>
              </button>
            </div>
            <div class="preview-container-unscrollable">
              <div 
                class="preview-container-frame"
                ref="previewContainerFrame"
                :style="previewContainerStyle"  
              >
                <div class="preview-image">
                  <img 
                    :src="getImageUrl(showMobileViewData)"
                    alt=""
                  />
                </div>
                <div class="preview-detail-container">
                  <em></em>
                  <div class="preview-detail-header">
                    <div class="preview-detail-title" v-if="validateIsAvailable(showMobileViewData?.issueStatus)">
                      {{ showMobileViewData?.products?.name }}
                    </div>
                    <div v-else>
                      {{ generateTitleText(showMobileViewData?.issueStatus) }}
                    </div>
                    <div 
                      class="preview-detail-desc" 
                      v-if="hasProductDetails && validateIsAvailable(showMobileViewData?.issueStatus)" 
                      v-html="productDescription" 
                      :class="isOpen ? 'is-open' : 'is-closed'"  
                    />
                    <div class="preview-detail-desc">
                      {{ generateTitleText(showMobileViewData?.issueStatus) }}
                    </div>
                    <p
                      v-if="!isOpen"
                      @click="showMore"
                      class="show-more"
                    >
                      더 보기
                    </p>
                  </div>
                  <div class="division-bar" />
                  <div 
                    class="preview-attributes-container"
                    v-if="hasProductAttributes && validateIsAvailable(showMobileViewData?.issueStatus)"  
                  >
                    <div 
                      class="preview-attribute-wrap"
                      v-for="(item, i) in showMobileViewData?.products.attributes"
                      :key="i"
                    >
                      <div class="preview-attributes-title">{{ item?.trait_type }}</div>
                      <div class="preview-attributes-content">{{ item?.value }}</div>
                    </div>
                  </div>
                  <div class="division-bar" />
                  <div class="preview-attributes-container">
                    <div class="preview-attribute-wrap">
                      <div class="preview-attributes-title">발행 시각</div>
                      <div class="preview-attributes-content">{{ convertDateTime(showMobileViewData?.createAt )}}</div>
                    </div>
                    <div class="preview-attribute-wrap">
                      <div class="preview-attributes-title">보낸 사람</div>
                      <div class="preview-attributes-content">자체 발행</div>
                    </div>
                    <div class="preview-attribute-wrap">
                      <div class="preview-attributes-title">트랜잭션 해시</div>
                      <button class="transaction-hash copy-button" @click="copyText">
                        0x341a2b....c3d4e5
                        <div class="copy-hash">
                          <i class="fa-regular fa-copy" />
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { 
  MedicalDept,
  YnEnum,
  OphCompanies,
  WarrantyStatusEnum,
  WarrantyImgUrlEnum,
 } from "@/enums/common.enums";
import { 
  CertifiedCompanies,
  SurfaceCompanies,
} from '@/enums/dent.enums';
import {
  phoneNumberFormatter,
  convertDate,
  convertDateTime,
  oneBtnDialog,
  twoBtnDialog,
  twoBtnHtmlDialog,
  getValueByTraitType,
  convertDeptText,
} from '@/utils/utils';
import { Variables } from '@/utils/variables';


export default {
  name: 'name',
  props: ['detailCustomerId', 'detailNftId'],
  components: {},
  data() {
    return {
      phoneNumberFormatter,
      defaultImageUrl: Variables.defaultNftInfo.defaultImageUrl,
      defaultColorCode: Variables.defaultNftInfo.defaultColorCode,
      customerInfo: {},
      nftList: [],
      showMobileViewIndex: 0,
      showMobileViewData: {},
      isOpen: false, 
      innerWidth: window.innerWidth,
      selectedTeethNumbers: 0, // 선택한 치아 "번호" 배열
      firstRowTeethArray: [
        18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28,
      ], // 첫 번째 줄 치아번호
      secondRowTeethArray: [
        48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38,
      ], // 두 번째 줄 치아번호
      dentPrevTeethArray: [],
      medicalDept: [],
      MedicalDept,
    };
  },
  async mounted() {
    this.preloadImage(this.defaultImageUrl);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    isWidthGreaterThan1000() {
      return this.innerWidth > 1000;
    },
    previewContainerStyle() {
      if(this.showMobileViewData?.issueStatus === WarrantyStatusEnum.DISPOSED) {
        return `background-color:${this.defaultColorCode}`;  
      }
      if(this.showMobileViewData?.issueStatus === WarrantyStatusEnum.RETURNED) {
        return `background-color:${this.defaultColorCode}`;  
      }
      const bgColor = this.showMobileViewData?.products?.background_color || this.defaultColorCode;
      return `background-color:${bgColor}`;
    },
    productImageSrc() {
      if(this.showMobileViewData?.products?.image && this.validateIsAvailable(this.showMobileViewData?.issueStatus)) {
        return this.showMobileViewData?.products?.image;
      } else {
        return this.defaultImageUrl;
      }
    },
    hasProductDetails() {
      return this.showMobileViewData && this.showMobileViewData.products;
    },
    hasProductAttributes() {
      return this.showMobileViewData?.products?.attributes;
    },
    productDescription() {
      return this.showMobileViewData?.products?.description;
    }
  },
  methods: {
    convertDate,
    handleResize() {
      this.innerWidth = window.innerWidth;
    },
    showMore() {
      this.isOpen = true;
    },
    scrollToTop() {
      this.$nextTick(() => {
        const customerInfoContainer = this.$refs.customerInfoContainer;
        const previewContainerFrame = this.$refs.previewContainerFrame;
        if (previewContainerFrame) {
          previewContainerFrame.scrollTo({
            top: 0,
          });
        }
        if(customerInfoContainer) {
          customerInfoContainer.scrollTo({
            top: 0,
          });
        }
        this.selectedTeethNumbers = 0;
      });
    },
    selectTooth(toothNum) {
      let index;
      for (let i = 0; i < this.nftList.length; i++) {
        const nft = this.nftList[i];

        if (!nft) continue; 

        const isAvailable = this.validateIsAvailable(nft.issueStatus);

        if (isAvailable) {
            let toothNo = 0;
          if (nft.surgeryArea && nft.surgeryArea.value) {
            toothNo = parseInt(nft.surgeryArea.value);
            if (isNaN(toothNo)) toothNo = 0; 
          } else {
            const traitValue = getValueByTraitType(nft.products?.attributes, '치아번호');
            toothNo = parseInt(traitValue);
            if (isNaN(toothNo)) toothNo = 0; 
          }
          if (toothNo === toothNum) {
            index = i;
            this.$nextTick(() => {
              setTimeout(() => {
                const element = document.getElementById('issueList' + i);
                if (element) {
                  element.focus();
                }
              }, 100);
            });
            this.selectedTeethNumbers = toothNum;
            this.showMobile(index);
            break;
          }
          this.selectedTeethNumbers = 0;
        }
      }
    },
    
    validateIsAvailable(message) {
      switch(message) {
        case 'returned':
        return false;
        case 'disposed':
        return false;
        case 'request-issued':
        return true;
        case 'Y':
        return true;
        case 'N':
        return true;
        default:
        return true;
      }
    },
    getToothImageSrc(tooth) {
      if (this.selectedTeethNumbers === tooth) {
        return require(`@/assets/img/tooth_images/tooth-${tooth}_selected.svg`);
      } else if (this.dentPrevTeethArray.includes(tooth)) {
        return require(`@/assets/img/tooth_images/tooth-${tooth}_implant.svg`);
      } else {
        return require(`@/assets/img/tooth_images/tooth-${tooth}.svg`);
      }
    },
    getImageUrl(item) {
      if(item?.issueStatus === WarrantyStatusEnum.DISPOSED) {
        return WarrantyImgUrlEnum.DISPOSED;
      }
      if(item?.issueStatus === WarrantyStatusEnum.RETURNED) {
        return WarrantyImgUrlEnum.RETURNED;
      }
      if(item?.products?.image) {
        return item?.products?.image;
      }
      return this.defaultImageUrl;
    },
    async fetchData(customerId, medicalDept) {
      this.$store.commit('setIsLoading', true);
      this.initData();
      this.medicalDept = medicalDept;
    console.log(medicalDept)

      try {
        const response = await this.$apiInstance.get(`/customers/v2/${customerId}`);

        if (response && (response.status === 200 || response.status === 201) && response.data) {
            const customerInfo = response.data.customerInfo;
            if (customerInfo) {
              this.customerInfo = customerInfo;
              this.customerInfo.mobile = customerInfo.deleteYn === YnEnum.Y
                ? customerInfo.mobile
                : phoneNumberFormatter(customerInfo.mobile);

                if (customerInfo.deleteYn !== YnEnum.Y && customerInfo.teethNos) {
                  this.dentPrevTeethArray = customerInfo.teethNos;
                }
            }

            if (Array.isArray(response.data.nftList)) {
              this.nftList = response.data.nftList;
              const newArray = [...this.dentPrevTeethArray];
              this.nftList.forEach((currentNFT, i) => {
                if (currentNFT) {
                  currentNFT.issueMessage = currentNFT.issueStatus || currentNFT.issueType;

                  const product = currentNFT.products;
                  if (product && product.group_name) {
                    currentNFT.products.background_color = 
                      currentNFT.issueStatus !== 'returned' && currentNFT.issueStatus !== 'disposed' 
                        ? product.background_color
                        : this.defaultColorCode;
                    if(product.group_name === CertifiedCompanies.dentium.name) {
                      currentNFT.products.background_color = CertifiedCompanies.dentium.colorCode;
                    } else if(product.group_name === SurfaceCompanies.plasmapp.name) {
                      currentNFT.products.background_color = SurfaceCompanies.plasmapp.colorCode;
                    } else if(product.group_name === OphCompanies.zeiss.name) {
                      currentNFT.products.background_color = OphCompanies.zeiss.colorCode;
                    }
                  }
                  const teethNo = getValueByTraitType(currentNFT.products?.attributes, '치아번호');
                  if(teethNo) {
                    newArray.push(parseInt(teethNo))
                  }
                  // if (currentNFT._id === nftId) {
                  //   this.showMobileViewIndex = i;
                  // }

                  currentNFT.descText = this.generateDescriptionText(currentNFT);
                }
              });

              if (this.nftList.length > 0) this.showMobile(this.showMobileViewIndex);
              const setArray = new Set(newArray);
              this.dentPrevTeethArray = Array.from(setArray);

            }
        }
      } catch(error) {
        console.log(error);
        this.$store.commit('setIsLoading', false);
        await oneBtnDialog('가져오기 실패', `인증서 내역 가져오기에 실패하였습니다.`);
        if(document.querySelector('.modal-backdrop')) {
          document.querySelector('.modal-backdrop').setAttribute('class', 'modal-backdrop fade hide');
        }
      } finally {
        this.$store.commit('setIsLoading', false);
      }
    },
    async recallNft(nftId, index) {
      const isConfirmed = await twoBtnDialog(`인증서 회수`, `환자에게 보낸 인증서를 회수하시겠습니까? 회수한 인증서는 새로운 내용으로 다시 발행할 수 있습니다.`, '회수');
      if(isConfirmed) {
        try {
          this.$store.commit('setIsLoading', true);
          const response = await this.$apiInstance.post(`/nfts/return/${nftId}`);
          if (response.status === 200 || response.status === 201) {
            oneBtnDialog(`인증서 회수 완료`, `인증서 회수가 완료되었습니다.`, false);
            this.nftList[index].issueMessage = WarrantyStatusEnum.RETURNED;
            this.nftList[index].issueStatus = WarrantyStatusEnum.RETURNED;
            this.showMobileViewData.issueMessage = WarrantyStatusEnum.RETURNED;
            this.showMobileViewData.issueStatus = WarrantyStatusEnum.RETURNED;
          }
          this.$store.commit('setIsLoading', false);
        } catch(error) {
          console.log(error);
          this.$store.commit('setIsLoading', false);
          oneBtnDialog(`인증서 회수 실패`, `인증서 회수에 실패하였습니다.`, false);
        }
      }
    },
    async disposeNft(nftId, index) {
      const isConfirmed = 
        await twoBtnHtmlDialog(
          `인증서 삭제`,
          `<p>정말로 인증서를 삭제하시겠습니까? 삭제할 경우, 
            <span style="color: #e73023;">같은 제품코드로는 다시 발행할 수 없습니다. </span>
          (재발행을 원하신다면 <span style="font-weight: 600;">"회수"</span> 버튼을 클릭하세요.) 
          이 작업은 취소할 수 없습니다.</p>`,
          '삭제'
        );
      if(isConfirmed) {
        try {
          this.$store.commit('setIsLoading', true);
          const response = await this.$apiInstance.post(`/nfts/dispose/${nftId}`);
          if (response.status === 200 || response.status === 201) {
            oneBtnDialog(`인증서 삭제 완료`, `인증서 삭제가 완료되었습니다.`, false);
            this.nftList[index].issueStatus = WarrantyStatusEnum.DISPOSED;
            this.nftList[index].issueMessage = WarrantyStatusEnum.DISPOSED;
            this.showMobileViewData.issueMessage = WarrantyStatusEnum.DISPOSED;
            this.showMobileViewData.issueStatus = WarrantyStatusEnum.DISPOSED;
          }
          this.$store.commit('setIsLoading', false);
        } catch(error) {
          console.log(error);
          this.$store.commit('setIsLoading', false);
          oneBtnDialog(`인증서 삭제 실패`, `인증서 삭제에 실패하였습니다.`, false);
        }
      }
    },
    showMobile(i) {
      this.showMobileViewIndex = i;
      this.showMobileViewData = this.nftList[i];
      this.isOpen = false;
      let toothNum = 0;

      if (this.showMobileViewData.surgeryArea && this.showMobileViewData.surgeryArea.value) {
        toothNum = parseInt(this.showMobileViewData.surgeryArea.value);
        if (isNaN(toothNum)) toothNum = 0; 
      } else {
        const traitValue = getValueByTraitType(this.showMobileViewData?.products?.attributes, '치아번호');
        toothNum = parseInt(traitValue);
        if (isNaN(toothNum)) toothNum = 0; 
      }

      this.$nextTick(() => {
        setTimeout(() => {
          const element = document.getElementById('issueList' + i);
          if (element) {
            this.selectedTeethNumbers = toothNum;
            element.focus();
          }
        }, 100); 
      });
    },
    generateTitleText(issueStatus) {
      switch(issueStatus) {
        case WarrantyStatusEnum.DISPOSED:
          return `삭제된 인증서입니다`;
        case WarrantyStatusEnum.RETURNED:
          return `회수된 인증서입니다`;
        default:
          return '';
      }
    },
    generateDescriptionText(nft) {
      //   ·
      // 병원, 시간, 수술부위, 
      let surgeryAreaText = '';
      let hospitalText = '';
      let createAtText = '';
      if(nft) {
        surgeryAreaText = this.getSurgeryPartText(nft);

        // 수술 병원은 attributes에서 찾기
        createAtText = convertDate(nft.createAt);
        // products가 있는 경우, 없는 경우 나누어야 함

        hospitalText = getValueByTraitType(nft.products?.attributes, '병원명');
      }

      let result = `${hospitalText}·${createAtText}·${surgeryAreaText}`;
      if(result.includes('undefined')) result.replace('undefined', '');
      return result;
    },
    preloadImage(url) {
      const img = new Image();
      img.src = url;
    },
    getSurgeryPartText(object) {
      if (!object.surgeryArea) {
          return this.getOldSurgeryPartText(object);
      }
      
      const { dept, value } = object.surgeryArea;
      
      if (dept === MedicalDept.DENT) {
          return `${value}번 치아`;
      }
      
      if (dept === MedicalDept.OPH) {
          return value;
      }
      
      return '';
    },
    getOldSurgeryPartText(object) {
      const nftItem = object.products ? object.products : object;
      const teethNum = getValueByTraitType(nftItem?.attributes, '치아번호');
      if (teethNum) {
          return `${teethNum} 번 치아`;
      }

      if (nftItem.name?.includes('좌안')) {
          return OphSurgeryPart.LEFT;
      }

      if (nftItem.name?.includes('우안')) {
          return OphSurgeryPart.RIGHT;
      }

      return '';
    },
    initData() {
      this.customerInfo = {};
      this.showMobileViewData = {};
      this.showMobileViewIndex = 0;
      this.isOpen = false;
      this.selectedTeethNumbers = 0;
      this.nftList = [];
      this.dentPrevTeethArray = [];
    },
    convertDateTime,
  },
};
</script>
<style lang="scss" scoped>

$Gray-10: #F1F2F3;
$Gray-20: #e8ebed;
$Gray-50: #ACB2B9;
$Gray-60: #8D939A;
$Gray-70: #6e747c;
$Gray-80: #4B5158;
$Gray-90: #2F3337;
$Gray-100 : #17191C;
$Yellow: #ffe414;
$CertiBlue : #278AEC;
$Font-medium: 500;
$Font-regular: 400;
$Font-semibold: 600;
$Font-bold: 700;
$Font-extrabold: 800;
$Font-heavy: 900;


#list-modal {
  .modal-content {
      max-height: 600px;
  }
  .modal-body {
      align-content: flex-start;
      align-items: flex-start;
      border-radius: 14px;
      display: flex;
      gap: 0px;
      height: 100%;
      justify-content: center;
      max-height: 600px;
      max-width: 960px !important;
      overflow: hidden;
      padding: 0;
      position: relative;
  }

  .inner-container {
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      align-items: flex-start;
      overflow-y: auto;  // Enables vertical scrolling
      max-height: 100%;  // Or an appropriate max height
      // overflow: hidden;
      .nft-list-modal-title {
          padding: 0 20px;
          justify-content: space-between;
          h4 {
              font-size: 17px;
              font-weight: 800;
              line-height: 1.4em;
              margin-bottom: 0 !important;
              color: $Gray-80;
          }
      }

      .customer-info-container {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-direction: column;
          max-width: 660px;
          max-height: 600px;
          // gap: 16px;
          overflow: hidden;
          padding: 20px 0;
          .customer-info {
              margin: 16px 0;
              padding: 0 20px;
              display: flex;
              align-items: start;
              justify-content: center;
              flex-direction: column;
              gap: 10px;
              width: 100%;
              .customer-info-row {
                  display: flex;
                  gap: 6px;
                  line-height: 1.2em;
                  font-size: 15px;
                  .customer-info-key {
                      width: 100px;
                      color: $Gray-60;
                  }
                  .customer-info-value {
                      color: $Gray-80;
                  }
              }
          }

          .division-bar {
              width: 100%;
              height: 1px;
              background-color: rgba(0,0,0,0.1);
          }

          .teeth-box-wrap {
              padding: 0 20px;
              margin-bottom: 16px;
              .teeth-area {
                  // display: none;
                  width: 100%;
                  height: 140px;
                  .teeth-container {
                      width: 585px;
                  }
              }
          }

          .nft-list-container {
              margin-top: 16px;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              max-width: 660px;
              gap: 16px;
              overflow: hidden;
              .nft-list {
                  padding: 0 20px;
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                  gap: 10px;
                  overflow-y: scroll;

                  .nft-item-wrap {
                      border: solid 1px rgba(0,0,0,0.1);
                      border-radius: 12px;
                      height: 80px;
                      width: 100%;
                      display: flex;
                      padding: 0 16px 0 20px;
                      gap: 20px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      min-height: 80px;
                      
                      .nft-image {
                          img {
                              width: 36px;
                          }
                      }

                      .nft-info {
                          height: 36px;
                          display: flex;
                          flex-direction: column;
                          width: 100%;
                          justify-content: center;
                          .nft-info-title {
                              color: $Gray-80;
                              font-weight: 800;
                              font-size: 15px;
                          }
                          
                          .nft-info-detail {
                              color: $Gray-60;
                              font-size: 13px;
                          }

                      }
                      .right-area {
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          gap: 20px;
                          .btn-container {
                              display: flex;
                              gap: 10px;
                              button {
                                  border: none;
                                  box-shadow: none;
                                  border-radius: 8px;
                                  height: 40px;
                                  width: 59px;
                                  border: 1px solid rgba(0,0,0,0.15);
                                  color:$Gray-70;
                                  background-color: white;
                                  font-size: 15px;
                              }
                          }
                          .nft-arrow {
                              i {
                                  color: $Gray-50;
                                  font-size: 16px;
                              }
                          }
                          .nft-arrow.selected {
                              i {
                                  color: $CertiBlue;
                              }
                          }
                      }

                      &:hover {
                          cursor: pointer;
                      }
                  }

                  .nft-item-wrap.selected {
                      border: 1.5px solid $CertiBlue;
                  }
              }
          }
      }

      .preview-container {
          width: 300px;
          padding: 20px;
          display: flex;
          flex: none;
          flex-direction: column;
          flex-wrap: nowrap;
          max-height: 600px;
          overflow: hidden;
          background-color: #f1f2f3;

          .title-container {
              justify-content: space-between;
              align-items: start;
          }

          h4 {
              font-size: 17px;
              font-weight: 800;
              line-height: 1.4em;
              margin-bottom: 16px !important;
              color: $Gray-80;
          }

          .btn-close {
              background-color: transparent;
              border: none;
              display: flex;
              align-items: center;
              justify-content: center;
              line-height: 1.4em;
              margin-bottom: 16px;
              i {
                  color: black;
              }
          }
          
          .preview-container-unscrollable {
              border-radius: 24px;
              border: 1px solid rgba(0,0,0,0.1);
              overflow-y: auto; 
              &::-webkit-scrollbar {
                  display: none;
              }
          }

          .preview-container-frame {
              display: flex;
              flex-direction: column;
   
              // height: 1px;
              overflow-y: auto;
              // flex: 1 0 0px;
              // height: 1px;              
              
              .preview-image {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 32px 0;
                  height: min-content;
                  img  {
                      width: 172px;
                  }
              }

              .preview-detail-container {
                  border-top-left-radius: 24px;
                  border-top-right-radius: 24px;
                  background-color: white;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  em {
                      margin-top: 10px;
                      margin-bottom: 20px;
                      border-radius: 4px;
                      width: 40px;
                      height: 4px;
                      background-color: #dde0e4;
                  }

                  .preview-detail-header {
                      width: 100%;
                      display: flex;
                      flex-direction: column;
                      justify-content: start;
                      padding: 0 14px 20px;
                      .preview-detail-title {
                          font-family: 'SuitExtraBold'; 
                          color: $Gray-80;
                          font-size: 13px;
                          line-height: 1.2em;
                      }
                      
                      .preview-detail-desc {
                          font-family: 'SuitRegular';
                          color: $Gray-80;
                          font-size: 11px;
                      }
                  }

                  .preview-attributes-container {
                      width: 100%;
                      padding: 0 14px;
                      margin: 20px 0;
                      gap: 16px;
                      display: flex;
                      flex-direction: column;
                      .preview-attribute-wrap {
                          white-space: pre-wrap;
                          width: 100%;
                          word-break: break-word;
                          word-wrap: break-word;
                          font-size: 11px;
                          line-height: 1.2em;
                          .preview-attributes-title {
                              color: $Gray-50;
                              font-weight: 800;
                              font-size: 11px;
                              margin-bottom: 4px;
                          }

                          .preview-attributes-content {
                              color: $Gray-80;
                          }
                      }
                  }

                  .show-more {
                      font-size: 11px;
                      color: $CertiBlue;
                      &:hover {
                          cursor: pointer;
                      }
                      margin-bottom: 0 !important;
                      text-align: end;
                  }

                  .is-open {

                  }

                  .is-closed {
                      display: -webkit-box;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                      -webkit-line-clamp: 5; 
                  }

                  .transaction-hash {
                      background-color: transparent;
                      border: none;
                      background-color: #f1f2f3;
                      display: flex;
                      padding: 0px 3px;
                      border-radius: 4px;
                      height: min-content;
                      width: min-content;
                      gap: 6px;
                      white-space: pre;
                      color: $Gray-80;
                      font-size: 11px;
                      align-items: center;
                      justify-content: center;
                      .copy-hash {
                          width: auto;
                          height: auto;
                          padding: 0;
                          color: $CertiBlue;
                      }
                  }
              }
          }
      }
  }
}
</style>
